<template>
  <div class="question-option">
    <!-- 编辑模式 -->
    <el-input
      v-if="isEditing"
      v-model="editLabel"
      size="small"
      ref="input"
      @blur="finishEdit"
      @keyup.enter="finishEdit"
      @keyup.esc="cancelEdit"
    />
    <!-- 展示模式 -->
    <div class="radio-option" v-else @click="startEdit">
      <el-radio
        :label="option.label"
        class="radio-button hover-border-box"
      ></el-radio>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditableRadioOption',
  props: {
    option: {
      type: Object,
      required: true, // { value, label }
    },
  },
  data() {
    return {
      isEditing: false,
      editLabel: '', // 本地编辑用的临时变量
    };
  },
  methods: {
    startEdit() {
      this.isEditing = true;
      this.editLabel = this.option.label; // 用本地变量保存当前 label
      this.$nextTick(() => {
        this.$refs.input?.focus();
      });
    },
    finishEdit() {
      // 不直接修改 this.option.label
      // 而是通过事件让父组件去改
      this.$emit('update-label', this.option.value, this.editLabel.trim());
      this.isEditing = false;
    },
    cancelEdit() {
      this.isEditing = false;
      // 不修改任何东西，直接退出编辑
    },
  },
};
</script>

<style scoped>
.question-option {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 2px 0;
  border-radius: 4px;
}

.radio-option {
  display: flex;
  align-items: center;
  width: 100%;
  border: 1px solid transparent;
  transition: border-color 0.3s;
}

.radio-button {
  margin-right: 12px;
  margin-top: 0 !important;
  min-height: 30px;
}

.option-label {
  font-size: 14px;
  color: #333;
  padding: 2px 0;
}

.el-radio__input {
  cursor: pointer;
  display: inline-flex;
  outline: none;
  position: relative;
  vertical-align: middle;
  white-space: nowrap
}

</style>
